/*
 * Copyright (c) Airbus SAS. All rights reserved.
 */

import ClipboardJS from 'clipboard'

/**
 * Wire a `.copy-to-clipboard` element to clipboard.js and show a toast on
 * success. Destroys the clipboard instance on disconnect.
 *
 * @type {Listener}
 */
export default {
    selector: '.copy-to-clipboard',
    connect(element, { app }) {
        const clipboard = new ClipboardJS(element)
        clipboard.on('success', () => {
            /** @type {ModalManager} */
            const modalManager = app.get('modalManager')
            modalManager.toast('success', 'Copied to clipboard')
        })

        return () => clipboard.destroy()
    },
}
